import * as actionTypes from '../actions/actionTypes.js'

const initialState = {
    selectedAccount: '',
    selectedDevice: '',
    selectedServiceOrder: '',
    header: {
        links: '',
        permissions: []
    }
}

const sel = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_SELECTED_ACCOUNT:
            // console.log('[redux/reducers/account.js]', action)
            return {
                ...state,
                selectedAccount: action.selectedAccount
            }
        case actionTypes.UPDATE_SELECTED_DEVICE:
            // console.log('[redux/reducers/account.js]', action)
            return {
                ...state,
                selectedDevice: action.selectedDevice
            }
        case actionTypes.UPDATE_SELECTED_SERVICEORDER:
            // console.log('[redux/reducers/account.js]', action)
            return {
                ...state,
                selectedServiceOrder: action.selectedServiceOrder
            }

        default: {
            // console.log('[redux/reducers/auth.js]', state)
            return state
        }
    }
}

export default sel
